var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',_vm._b({ref:"canvas"},'canvas',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }